import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";

const DialogComp = ({ openPopup, closeFunc, popuptitle, popupContent, buttonValue }) => {
  return (
    <Dialog open={openPopup} onClose={closeFunc}>
      <DialogTitle>{popuptitle}</DialogTitle>
      <DialogContent>
        <p>{popupContent}</p>
      </DialogContent>
      <DialogActions>
        {buttonValue.map((button) => (
          <Button
            key={button.id}
            onClick={button.functionCall}
            style={{
              fontWeight: button.fontWeight,
              border: button.color === "borderLess" ? "none" : "1px solid #000",
            }}
          >
            {button.value}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
};

export default DialogComp;
